import { CommonModule } from "@angular/common";
import { Injector, NgModule } from "@angular/core";
import { AdaptFeatureModule } from "@common/feature/feature.module";
import { AdaptImplementationKitModule } from "@common/implementation-kit/implementation-kit.module";
import { BreezeService } from "@common/lib/data/breeze.service";
import { IBreezeParameter } from "@common/lib/data/breeze-parameter.interface";
import { AdaptPaymentProcessingModule } from "@common/payment-processing/payment-processing.module";
import { AdaptCommonDialogModule } from "@common/ux/adapt-common-dialog/adapt-common-dialog.module";
import { AdaptButtonModule } from "@common/ux/button/button.module";
import { AdaptCollapsibleModule } from "@common/ux/collapsible/collapsible.module";
import { AdaptDateModule } from "@common/ux/date/date.module";
import { AdaptLoadingSpinnerModule } from "@common/ux/loading-spinner/loading-spinner.module";
import { AdaptTooltipModule } from "@common/ux/tooltip.directive/tooltip.module";
import { DxButtonGroupModule, DxCheckBoxModule, DxTemplateModule } from "devextreme-angular";
import { AuthorisationService } from "../authorisation/authorisation.service";
import { AdaptCommonConfigurationModule } from "../configuration/configuration.module";
import { AdaptDirectorySharedModule } from "../directory-shared/directory-shared.module";
import { AdaptEulaModule } from "../eula/eula.module";
import { providePostOrganisationGuardValidator } from "../route/organisation.guard";
import { SetInitialSubscriptionDialogComponent } from "./account/set-initial-subscription-dialog/set-initial-subscription-dialog.component";
import { OrganisationService } from "./organisation.service";
import { OrganisationAuthService } from "./organisation-auth.service";
import { provideOrganisationEntityUpdatedEventHandler } from "./organisation-event-handler.interface";
import { OrganisationIdentifierTracker } from "./organisation-identifier-tracker.service";
import { validateSubscription } from "./subscription-validator";

@NgModule({
    imports: [
        CommonModule,
        AdaptCommonConfigurationModule,
        AdaptCommonDialogModule,
        AdaptLoadingSpinnerModule,
        AdaptPaymentProcessingModule,
        AdaptTooltipModule,
        AdaptDateModule,
        AdaptButtonModule,
        DxButtonGroupModule,
        DxTemplateModule,
        DxCheckBoxModule,
        AdaptImplementationKitModule,
        AdaptCollapsibleModule,
        AdaptFeatureModule,
        AdaptEulaModule,
        AdaptDirectorySharedModule,
    ],
    declarations: [
        SetInitialSubscriptionDialogComponent,
    ],
    providers: [
        provideOrganisationEntityUpdatedEventHandler(OrganisationIdentifierTracker),
        providePostOrganisationGuardValidator(validateSubscription),
    ],
})
export class AdaptOrganisationModule {
    constructor(authorisationService: AuthorisationService) {
        const orgIdInvoker = {
            paramName: "organisationId",
            invoker: (injector: Injector) => {
                const orgService = injector.get(OrganisationService);
                return orgService.getOrganisationId();
            },
            valueIsValid: (orgId) => orgId > 0,
            waitObservable: (injector: Injector) => {
                const orgService = injector.get(OrganisationService);
                return orgService.waitForOrganisationEntity();
            },
        } as IBreezeParameter<number>;
        BreezeService.setOrganisationIdInvoker(orgIdInvoker);

        OrganisationAuthService.registerAccess(authorisationService);
    }
}
